import { render, staticRenderFns } from "./MainProjects.vue?vue&type=template&id=c6ee3fce"
import script from "./MainProjects.vue?vue&type=script&lang=js"
export * from "./MainProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports